import { useQuery } from '@pinia/colada';
import { computed } from 'vue';

import portfolioService from '../services/portfolio.service';

export const companyPortfoliosQueryKey = 'company-portfolios';

export function useCompanyPortfoliosQuery() {
  const query = useQuery({
    key: () => [companyPortfoliosQueryKey],
    query: () => portfolioService.list(),
  });

  return { ...query, portfolios: computed(() => query.data.value ?? []) };
}
